import React, {useState, useEffect, Fragment} from 'react';
import {axiosInstance} from "../../../utils/axiosInstance";
import Notification from 'components/alert/Notification';
import PersianDate from "components/calendar/PersianDate";
import Loader from "react-spinners/PropagateLoader";
import Card from 'components/card';
import {MdBlock, MdCheck, MdDelete, MdEdit, MdPinDrop, MdVisibility} from "react-icons/md";
import {deleteNews, fetchAllNews} from "../../../services/news";
import {timeAgo} from "../../../utils/time";
import ReactPaginate from 'react-paginate';
import {Link, useNavigate} from "react-router-dom";
import AdvancedSearch from "../../../components/search/advancedSearch";
import Select from 'react-select'
import AsyncSelect from "react-select/async";
import {format} from 'date-fns';
import {NotImplementedError} from "../../../utils/exceptions/NotImplementedError";
import type {SelectboxOption} from "../../../utils/types";
import {fetchAllCategories} from "../../../services/categories";
import DynamicForm from "../../../components/form/dynamicForm";
import {InputDatePicker} from "jalaali-react-date-picker";
import AsyncCreatableSelect from "react-select/async-creatable";
import * as Yup from "yup";
import {newsTypeOptions} from "../../../services/types/news";
import Modal from "react-modal";


// Define types for rules
type StringRules = {
    max_length?: number; // Max length for a string type
    min_length?: number; // Min length for a string type
    regex?: RegExp; // Regular expression validation for strings
};

type DateTimeRules = {
    datetime_format?: 'iso' | 'locale' | 'ago'; // Format options for datetime
    allow_future?: boolean; // Whether future dates are allowed
    allow_past?: boolean; // Whether past dates are allowed
    datetime_type?: 'jalali' | 'georgian';
};

type BoolRules = {
    trueLabel?: string; // Label for true value
    falseLabel?: string; // Label for false value
};

type LinkRules = {
    linkTemplate: string; // Template for generating the link
    newTab?: boolean; // Whether to open the link in a new tab
};

type ColumnRules = StringRules | DateTimeRules | BoolRules | LinkRules;

// Define a type for each column
type ColumnType = 'string' | 'datetime' | 'bool' | 'link';

type Accessor = string | string[] | ((row: any, column: any) => any);


// Define the structure for a column
type Column = {
    Header: string;
    accessor: Accessor;
    type: ColumnType;
    rules?: ColumnRules;
    htmlTemplate?: (value: any, row: any, column: any) => string; // Optional custom HTML template
};

// Define types for actions
type Action = {
    template: (row: any) => JSX.Element; // Template that returns JSX for rendering
};

const Requests = () => {
    useEffect(() => {
        const loadTagsOptions = async () => {
            const tagsSearchResponse = await axiosInstance.get('tags');
            const tags = tagsSearchResponse.data.results;

            const mappedTagOptions = tags.map((tag) => ({
                value: tag.id, label: tag.name, createdAt: tag.created_at
            }));

            // Update the tagsOptions with newly fetched options
            setTagsOptions((prevOptions) => {
                return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
            });
        }
        loadTagsOptions()
        fetchAllNews()
    }, [])
    // tags
    const [tagsOptions, setTagsOptions] = useState([]);
    const [tagsLoading, setTagsLoading] = useState(false)

    // delete modal
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)


    // dynamic form
    const meta = {
        gridColumns: {
            small: 1, medium: 3, large: 4
        },
    };

    // const searchFields = [{
    //     title: 'عنوان', fieldName: 'title', type: 'string', validation: (value) => {
    //     },
    // }, {
    //     title: 'طبقه بندی',
    //     fieldName: 'category',
    //     type: 'selectbox',
    //     options: [{value: 1, label: 'Technology'}, {value: 2, label: 'Business'}],
    //     validation: (value) => {
    //     },
    // }, {
    //     title: 'نوع',
    //     fieldName: 'type',
    //     type: 'selectbox',
    //     options: newsTypeOptions,
    //     validation: (value) => {
    //     },
    // }, {
    //     title: 'تگ ها', fieldName: 'tags', type: 'custom', validation: () => null,
    //     template: (formik, fieldName) => (<AsyncCreatableSelect
    //         isClearable
    //         // isDisabled={tagsLoading}
    //         isMulti
    //         isLoading={tagsLoading}
    //         defaultOptions={tagsOptions} // Ensure this is set properly
    //         onChange={(option) => formik.setFieldValue(fieldName, option)}
    //         formatCreateLabel={(inputText) => `ساخت "${inputText}"`}
    //         loadOptions={async (value) => {
    //             setTagsLoading(true); // Start loading when fetching options
    //             const tagsSearchResponse = await axiosInstance.get('tags', {
    //                 params: {name: value}
    //             });
    //             const tags = tagsSearchResponse.data.results;
    //
    //             const mappedTagOptions = tags.map((tag) => ({
    //                 value: tag.id, label: tag.name,
    //             }));
    //
    //             // Update the tagsOptions with newly fetched options
    //             setTagsOptions((prevOptions) => {
    //                 return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
    //             });
    //
    //             setTagsLoading(false); // End loading after fetching options
    //             return mappedTagOptions;
    //         }}
    //         onCreateOption={async (inputValue) => {
    //             setTagsLoading(true); // Start loading while creating
    //             const createTagResponse = await axiosInstance.post('tags', {name: inputValue});
    //             const newTag = {
    //                 value: createTagResponse.data.data.id, label: inputValue, createdAt: new Date().toISOString(),
    //             };
    //
    //             // Update tagsOptions to include the new tag
    //             setTagsOptions((prev) => {
    //                 let newOptions = [...prev, newTag];
    //                 newOptions.sort((a, b) => {
    //                     return a.createdAt > b.createdAt ? 1 : -1;
    //                 })
    //                 return Array.from(new Map(newOptions.map(item => [item.value, item])).values());
    //             });
    //
    //             setTagsLoading(false); // End loading
    //             await formik.setFieldValue(fieldName, newTag); // Set the new tag in Formik state
    //             return newTag; // Return the new tag to be added in the select options
    //         }}
    //         isRtl
    //         placeholder="جستجو و انتخاب کنید و در صورت لزوم بسازید"
    //     />),
    // }, {
    //     title: 'زمان انتشار',
    //     fieldName: 'published_at',
    //     type: 'custom',
    //     validation: (value) => {
    //     },
    //     template: (formik, fieldName) => (<div>
    //         <InputDatePicker
    //             value={formik.values[fieldName]}
    //             onChange={(date) => formik.setFieldValue(fieldName, date)}
    //         />
    //     </div>),
    // }, {
    //     title: 'پیشنهاد سردبیر',
    //     fieldName: 'editor_suggestion',
    //     type: 'checkbox',
    //     validation: () => {
    //     },
    // }
    // ];
    const searchFields = [{
        title: 'عنوان', fieldName: 'title', type: 'string', validation: (value) => {
        },
    }]


    // Example newsColumns with defined rules for each type
    const newsColumns: Column[] = [{
        Header: 'عنوان', accessor: 'title', type: 'string',
    }, {
        Header: 'تعداد بازدید', accessor: 'views_count', type: 'string',
    }, {
        Header: 'نویسنده',
        accessor: (row) => row.author.first_name + ' ' + row.author.last_name,
        type: 'string',
        rules: {
            max_length: 50
        },
        htmlTemplate: (value) => `<p class="text-blue-500">${value}</p>` // Example HTML template
    }, {
        Header: 'تاریخ', accessor: 'updated_at', type: 'datetime', rules: {
            datetime_format: 'ago',
        }
    }, {
        Header: 'پیشنهاد سر دبیر', accessor: 'editor_suggestion', type: 'bool', rules: {
            trueLabel: 'بله', falseLabel: 'خیر'
        },
    },{
        Header: 'فعال', accessor: 'is_active', type: 'bool', rules: {
            trueLabel: 'بله', falseLabel: 'خیر'
        },
    },];
    // Search Configurations with Pinning Option
    const [searchConfigs, setSearchConfigs] = useState([{
        label: 'تاریخ', accessor: 'publishDate', type: 'date', pinned: true
    }, {label: 'نویسنده', accessor: 'author.first_name', type: 'string', pinned: false}, {
        label: 'پیشنهاد سر دبیر', accessor: 'editorSuggestion', type: 'boolean', pinned: false
    },]);

    // News Data and State Management
    const [newsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState(null);
    const [filters, setFilters] = useState({});

    // pagination controllers
    const [currentPage, setCurrentPage] = useState(1); // Track current page
    const [totalItems, setTotalItems] = useState(0); // Track total items
    const pageSize = 5
    const [totalPages, setTotalPages] = useState(0)
    const [havePagination, setHavePagination] = useState(true); // Boolean to toggle pagination

    const [categoryCurrentPage, setCategoryCurrentPage] = useState(1)

    const closeNotification = () => setNotification(null);

    const navigate = useNavigate();

    // Fetch News Data with Pagination and Filters
    const fetchData = async (page = 1, search_params = {}) => {
        if (page === 0) page = 1
        setLoading(true);
        try {
            const response = await fetchAllNews({page: page, page_size: pageSize, ...search_params});
            setNewsData(response.data.results);
            setTotalItems(response.data.count); // Set total number of items from response
            setTotalPages(Math.ceil(response.data.count / pageSize))
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setNotification(<Notification text="خطا در دریافت اخبار" type="error"
                                          closeNotification={closeNotification}/>);
        }
    };

    // Dynamic actions for each row
    const actions: Action[] = [{
        template: (row) => (
            <Link to={`edit/${row.id}`} className="text-blue-500 hover:text-blue-700">
                <MdEdit className="w-5 h-5"/>
            </Link>)
    }, {
        template: (row) => (
            <button className="text-red-500 hover:text-red-700" onClick={() => openDeleteNewsModal(row)}>
                <MdDelete className="w-5 h-5"/>
            </button>)
    }];


    const [deleteNewsModal, setDeleteNewsModal] = useState(null)
    const openDeleteNewsModal = (news) => {
        setDeleteNewsModal(news)
        setIsDeleteModalOpen(true)
    }

    // useEffect(() => {
    //     fetchData(currentPage);
    // }, [filters, currentPage]);

    // Handle page change event
    const handlePageClick = async (data) => {
        setCurrentPage(data.selected + 1); // Set the current page, react-paginate pages are 0-indexed
        await fetchData(data.selected + 1, {
            editor_suggestion: filterEditorSuggestion,
            search: filterTextSearch,
            category: filterCategoryId,
            page_size: pageSize,
        })
    };

    // Handle Pin/Unpin Search Option
    const togglePinSearch = (index) => {
        const updatedConfigs = [...searchConfigs];
        updatedConfigs[index].pinned = !updatedConfigs[index].pinned;
        setSearchConfigs(updatedConfigs);
    };

    // Handle Search Input Change
    const handleSearchChange = (accessor, value) => {
        setFilters((prev) => ({
            ...prev, [accessor]: value,
        }));
    };

    // Helper Functions
    // Example function to get value based on the rules
// Modified getValue function to handle string, array, and callback accessor
    const getValue = (row: any, column: Column) => {
        let value: any = null;

        // Handle if accessor is a function (custom accessor logic)
        if (typeof column.accessor === 'function') {
            value = column.accessor(row, column);
        }
        // Handle if accessor is an array of keys (e.g., author.first_name + author.last_name)
        else if (Array.isArray(column.accessor)) {
            value = column.accessor.map((key) => {
                const keys = key.split('.');
                return keys.reduce((acc, curr) => (acc ? acc[curr] : null), row);
            }).join(' ');
        }
        // Handle if accessor is a simple string key
        else {
            const keys = column.accessor.split('.');
            value = keys.reduce((acc, curr) => (acc ? acc[curr] : null), row);
        }

        // Apply rules to value as needed
        const rules = column.rules;

        // Example rule: datetime formatting
        if (column.type === 'datetime' && rules && 'datetime_format' in rules) {
            if (rules.datetime_format === 'ago') {
                value = timeAgo(value);
            } else if (rules.datetime_format === 'persian') {
                throw NotImplementedError()
            } else if (rules.datetime_format === "iso") {
                throw NotImplementedError()
            } else {
                // format the datetime
                value = format(new Date(value), rules.datetime_format); // Example format, adjust as needed
            }
        }

        // Example rule: string length limit
        if (column.type === 'string' && rules && 'max_length' in rules) {
            if (value.length > rules.max_length) {
                value = value.substring(0, rules.max_length) + '...';
            }
        }

        // Apply HTML template if defined
        if (column.htmlTemplate) {
            return column.htmlTemplate(value, row, column); // Return HTML string
        }

        return value;
    };
    const generateLink = (template, row) => {
        return template.replace(/\$\{([^}]+)\}/g, (_, key) => {
            const keys = key.split('.');
            return keys.reduce((acc, curr) => (acc ? acc[curr] : null), row) || '';
        });
    };

    // Delete Item Function
    const DeleteItem = async (type, id) => {
        if (type === "news") {
            setLoading(true);
            try {
                await axiosInstance.delete(`api/News/DeleteNews?id=${id}`);
                handleMessage('خبر مورد نظر با موفقیت حذف شد');
            } catch (error) {
                console.log('Error in deleting news:', error);
                handleError('حذف خبر مورد نظر با مشکل مواجه شد!');
            }
            setLoading(false);
        }
        // Add other types if needed
    };

    // Handle Success Message
    const handleMessage = (text) => {
        setNotification(<Notification
            text={text}
            type='success'
            closeNotification={closeNotification}
        />);
        window.scrollTo(0, 0);
    };

    // Handle Error Message
    const handleError = (text) => {
        setNotification(<Notification
            text={text}
            type='error'
            closeNotification={closeNotification}
        />);
        window.scrollTo(0, 0);
    };

    const searchTypes = {
        name: 'text', isActive: 'boolean', category: 'selectbox',
    };

    const customFunctions = {
        category: async (searchTerm) => {
            // Fetch categories based on searchTerm
            // Return array of { value, label } objects
        }, categoryLoadMore: async () => {
            // Fetch next page of categories
            // Return array of { value, label } objects
        },
    };

    const [filterTextSearch: string | null, setFilterTextSearch] = useState(null)
    const [filterEditorSuggestion: boolean | null, setFilterEditorSuggestion] = useState(null)
    const [filterCategoryId: number | null, setFilterCategoryId] = useState(null)
    const [deletedNewsCount, setDeletedNewsCount] = useState(0)

    // Unified loadOptions function
    const loadCategories = async (inputValue?: string): Promise<SelectboxOption[]> => {
        try {
            const response = await fetchAllCategories({
                page: 1, page_size: inputValue ? 5 : 100,
            });

            // Map the fetched categories to the format expected by AsyncSelect
            return response.data.results.map((category) => ({
                value: category.id, label: category.name,
            }));
        } catch (error) {
            console.error('Error fetching categories:', error);
            return [];
        }
    };


    useEffect(() => {
        const fetchNewsData = async () => {
            await fetchData(currentPage, {
                editor_suggestion: filterEditorSuggestion,
                search: filterTextSearch,
                category: filterCategoryId,
                page_size: pageSize,
            })
        }
        fetchNewsData()
    }, [filterTextSearch, filterCategoryId, filterEditorSuggestion, deletedNewsCount]);
    const searchElements = [{name: 'عنوان', type: 'text', changeCallback: (value) => setFilterTextSearch(value)}, {
        name: 'طبقه بندی ها',
        type: 'custom',
        customElement: <AsyncSelect cacheOptions defaultOptions loadOptions={loadCategories} isRtl={true}
                                    placeholder="جستجو کنید" noOptionsMessage={() => 'یافت نشد'}
                                    onChange={(value) => setFilterCategoryId(value.value)}
        />
    }, // {name: 'برگزیده سردبیر', type: 'boolean', changeCallback: (value) => setFilterEditorSuggestion(value)},
        {
            name: 'برگزیده سردبیر',
            type: 'custom',
            customElement: <Select isRtl options={[{value: null, label: 'همه'}, {value: true, label: 'بله'}, {
                value: false, label: 'خیر'
            },]} onChange={(value: SelectboxOption) => setFilterEditorSuggestion(value.value)} defaultValue={null}
                                   placeholder="انتخاب کنید"
            />
        }];

    async function searchNews() {
        await fetchData(1, {
            page: 1, editor_suggestion: filterEditorSuggestion, search: filterTextSearch, category: filterCategoryId
        })
        // const news = filteredNewsResponse.data.results
        // setNewsData(news)
    }

    const deleteNewsAndCloseDeleteModal = async (news) => {
        await deleteNews(news.id)
        setDeletedNewsCount(prev => prev + 1)
        setIsDeleteModalOpen(false)
    }

    return (<div className="flex flex-col p-4">
        <Modal
            isOpen={isDeleteModalOpen}
            contentLabel="حذف"
            className="m-auto"
        >
            <>
                <div
                    className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                >
                    <div className="relative w-auto my-6 mx-auto max-w-3xl">
                        {/*content*/}
                        <div
                            className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            {/*header*/}
                            <div
                                className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                <h3 className="text-3xl font-semibold">
                                    حذف خبر
                                </h3>
                            </div>
                            {/*body*/}
                            <div className="relative p-6 flex-auto">
                                <span className="my-4 text-blueGray-500 text-lg leading-relaxed">
                                    آیا از حذف خبر
                                    <p className="text-red-500 text-center"> {deleteNewsModal?.title} </p>
                                    مطمئن هستید؟
                                </span>
                            </div>
                            {/*footer*/}
                            <div
                                className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                <button
                                    className="text-blue-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => setIsDeleteModalOpen(false)}
                                >
                                    بستن
                                </button>
                                <button
                                    className="bg-red-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => deleteNewsAndCloseDeleteModal(deleteNewsModal)}
                                >
                                    حذف
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
        </Modal>
        {notification}

        <Card extra="mt-6">
            <div className="mt-5 p-4 md:p-8 h-full">
                <div className='flex'>
                    <h3 className="text-lg font-bold text-gray-700">لیست اخبار</h3>
                    <Link className='bg-blue-500 mx-4 hover:bg-blue-600 text-white px-3 rounded-lg'
                          to={'create'}>افزودن</Link>
                </div>

                {/* Search Section */}
                <div className="bg-white p-4 rounded-lg shadow-md mb-6">
                    <DynamicForm
                        fields={searchFields}
                        meta={meta}
                        onSubmit={(values) => {
                            setFilterTextSearch(values.title)
                            setFilterCategoryId(values.category)
                            setFilterEditorSuggestion(values.editor_suggestion)
                        }}
                        submitText="جستجو"
                    />
                </div>

                {/* News Table */}
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden shadow-md sm:rounded-lg max-h-[50vh] overflow-y-auto">
                            {loading ? (<div className="flex items-center justify-center h-20 text-indigo-600">
                                <Loader loading={true} color="#422AFB"/>
                            </div>) : (<>
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-200">
                                    <tr>
                                        {newsColumns.map((column) => (<th
                                            key={column.accessor.toString()}
                                            className="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider"
                                        >
                                            {column.Header}
                                        </th>))}
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider">
                                            عملیات
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {newsData.map((row, rowIndex) => (<tr key={rowIndex}>
                                        {newsColumns.map((column) => (<td
                                            key={column.accessor.toString()}
                                            className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        >
                                            {/* Render content based on column type */}
                                            {column.type === 'link' ? (<a
                                                href={generateLink(column.rules?.linkTemplate || '', row)}
                                                className="text-blue-500 hover:underline"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                مشاهده
                                            </a>) : column.type === 'bool' ? (row[column.accessor] ? <MdCheck/> :
                                                <MdBlock/>) : column.htmlTemplate ? (<div
                                                dangerouslySetInnerHTML={{__html: getValue(row, column)}}/>) : (getValue(row, column))}
                                        </td>))}
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {actions.map((action, actionIndex) => (<div key={actionIndex}
                                                                                        className="px-5 py-2 whitespace-nowrap inline-table text-sm text-gray-900 text-center">
                                                {action.template(row)} {/* Render the action's template */}
                                            </div>))}
                                        </td>
                                    </tr>))}
                                    </tbody>
                                </table>

                                {/* Pagination */}
                                {havePagination && (<div className="flex justify-between items-center mt-4">
                                    <div className="text-sm text-gray-600 px-4">
                                        نمایش {Math.min((currentPage - 1) * pageSize + 1, totalItems)} تا {Math.min(currentPage * pageSize, totalItems)} از {totalItems} مورد
                                    </div>
                                    <ReactPaginate
                                        previousLabel={'قبلی'}
                                        nextLabel={'بعدی'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        pageCount={totalPages}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        pageClassName={'inline-block px-4 py-2 border rounded text-sm'}
                                        previousClassName={'inline-block px-4 py-2 border rounded text-sm'}
                                        nextClassName={'inline-block px-4 py-2 border rounded text-sm'}
                                        activeClassName={'bg-blue-500 text-white'}
                                        previousLinkClassName={'text-blue-500 hover:underline'}
                                        nextLinkClassName={'text-blue-500 hover:underline'}
                                        disabledClassName={'opacity-50 cursor-not-allowed'}
                                        activeLinkClassName={'text-white'}
                                        pageLinkClassName="rtl:text-left"
                                        containerClassName="rtl:space-x-reverse rtl:flex rtl:justify-center px-6"
                                        forcePage={currentPage - 1}
                                    />
                                </div>)}
                            </>)}
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    </div>);
};

export default Requests;